/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".technical-details[_ngcontent-%COMP%]{display:block}#loading[_ngcontent-%COMP%]{position:relative;top:150px}.login-error-message[_ngcontent-%COMP%]{position:relative;top:20px}button[_ngcontent-%COMP%]{position:relative;margin:20px 20px 0 0}#error-message-container[_ngcontent-%COMP%]{position:relative;top:30px;height:50px;width:100%}.error-msg[_ngcontent-%COMP%]{position:relative;max-width:250px;color:red}\n/*# sourceMappingURL=loading.component.css.map*/"];
export { styles as styles };
